import { Outlet } from "react-router-dom";
import InboxPage from "./Inbox";

export const adminInboxRoutes = [
  {
    path: "inbox",
    element: Outlet,
    children: [
      {
        path: "",
        element: InboxPage,
      },
    ],
  },
];
